<template>
  <v-layout wrap row justify-space-between>
    <v-flex xs12 md6 lg6>
      <v-layout wrap row>
        <v-flex>
          <v-text-field
            v-model="filters.search"
            label="Nombre del tutor"
            @click:append-outer="filterSearch(false)"
            @click:clear="filterSearch(true)"
            @keyup.enter="filterSearch(false)"
            append-icon="search"
            :disabled="working.wUpdate"
            :autofocus="!working.wUpdate"
            clearable
          >
            <template v-slot:prepend>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">help</v-icon>
                </template>
                Escribe el nombre del padre o tutor
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-card-text>
          <v-list subheader two-line>
            <v-subheader>Selecciona uno o varios tutores</v-subheader>
            <template v-for="(item, index) in parents">
              <v-list-tile :key="index" avatar>
                <v-list-tile-action>
                  <v-checkbox
                    color="primary"
                    :value="item"
                    :id="'' + (item ? item.id : index)"
                    v-model="selectedParents"
                    v-bind:key="item.id"
                    :value-comparator="compareParents"
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-avatar>
                  <v-icon>account_circle</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="item.firstName + ' ' + item.lastName"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="item.mail"
                  ></v-list-tile-sub-title>
                  <v-divider :key="index" :inset="true"></v-divider>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card-text>
      </v-layout>
    </v-flex>
    <v-flex xs12 md6 lg5>
      <v-layout>
        <v-flex xs12>
          <v-list subheader two-line dense>
            <v-subheader>Tutores seleccionados</v-subheader>
            <template v-for="(item, index) in selectedParents">
              <v-list-tile :key="index" avatar>
                <v-list-tile-action>
                  <v-btn @click="unselectParent(item)" icon>
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-tile-action>

                <v-list-tile-avatar>
                  <v-icon>account_circle</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="item.firstName + ' ' + item.lastName"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="item.mail"
                  ></v-list-tile-sub-title>
                  <v-divider :key="index" :inset="true"></v-divider>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
          <p
            class="pl-3 mb-0 text--secondary"
            v-if="selectedParents.length === 0"
          >
            No hay tutores seleccionados
          </p>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['sourceParents'],
  components: {},
  mounted() {
    this.selectedParents = this.sourceParents || []
    this.parents = []

    this.getAllParents()
    document
      .getElementById('PopupContainer')
      .addEventListener('scroll', this.handleScroll)
  },
  data: () => ({
    working: {
      wUpdate: false,
    },
    selectedParents: [],
    parents: [],
    totalParents: 0,
    filters: {
      size: 10,
      offset: 0,
      search: '',
    },
  }),
  watch: {
    selectedParents() {
      this.$emit('onSelectParent', this.selectedParents)
    },
  },
  methods: {
    unselectParent(parent) {
      this.selectedParents = this.selectedParents.filter(function (p) {
        return parent.id !== p.id
      })
    },
    filterSearch(clean) {
      this.filters.offset = 0
      if (clean) {
        this.filters.search = ''
      }
      if (!this.working.wUpdate) {
        this.getAllParents(true)
      }
    },
    handleScroll() {
      var event = document.getElementById('PopupContainer')
      if (event.offsetHeight + event.scrollTop >= event.scrollHeight) {
        if (this.parents.length < this.totalParents) {
          this.filters.offset = this.parents.length + 1
          this.getAllParents()
        }
      }
    },
    getAllParents(flag = false) {
      this.working.wUpdate = true
      this.$store
        .dispatch('tutor/getTutors', this.filters)
        .then((response) => {
          this.parents = flag
            ? response.data.data
            : this.parents.concat(response.data.data)
          this.working.wUpdate = false
          this.totalParents = response.data.total
        })
        .catch((error) => {
          console.error(error)
          this.working.wUpdate = false
        })
    },
    compareParents(a1, a2) {
      return a1 && a2 && a1.id === a2.id
    },
  },
  computed: {
    filteredItems() {
      if (!this.filters.search) return this.students
      return this.students.filter((item) => {
        var transformMap = {
          a: '[aá]',
          e: '[eé]',
          i: '[ií]',
          o: '[oó]',
          u: '[uí]',
          A: '[AÁ]',
          E: '[EÉ]',
          I: '[IÍ]',
          O: '[OÓ]',
          U: '[UÚ]',
        }
        var search = this.filters.search
        search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        for (var key in transformMap) {
          search = search.replace(key, transformMap[key])
        }
        var matcher = new RegExp(search, 'i')
        return matcher.test(
          [
            item.firstName,
            item.lastName,
            item.firstName + ' ' + item.lastName,
          ].join()
        )
      })
    },
  },
}
</script>

<style></style>
